<template>
    <div class="columns is-multiline">
        <div class="column is-half">
            <article class="panel is-info">
                <b-loading :is-full-page="false" :active.sync="anonCload" :can-cancel="true"></b-loading>
                <div class="panel-heading">
                    <p class="heading">Carros anonimos</p>
                    <p class="title has-text-white">UY$ {{anonCsum}}</p>
                </div>
                <a v-for="ord in anonC" :key="ord.id" class="panel-block">
                    <p>
                        {{ord.userEmail}} 
                        <span class="tag is-success is-rounded">UY${{ord.totalInUy}}</span>
                        <span class="tag is-info  is-rounded m-l-5">
                            {{ new Date(ord.lastModified).toLocaleDateString() }}
                        </span>
                        </p> 
                </a>
            </article>
        </div>
        <div class="column is-half">
            <article class="panel is-danger">
                <b-loading :is-full-page="false" :active.sync="userCload" :can-cancel="true"></b-loading>
                <div class="panel-heading">
                    <p class="heading">Carros identificados</p>
                    <p class="title has-text-white">UY$ {{userCsum}}</p>
                </div>
                <a v-for="ord in userC" :key="ord.id" class="panel-block">
                    <p>
                        {{ord.userEmail}} 
                        <span class=" tag is-success is-rounded">UY${{ord.totalInUy}}</span>
                        <span class="tag is-info is-rounded m-l-5">
                            {{ new Date(ord.lastModified).toLocaleDateString() }}
                        </span>
                    </p> 
                </a>
            </article>
        </div>
    </div>
</template>

<script>
import { getHandler } from '../../../../services/http'
export default {
    props:{
        anonCarts:{
            type:String,
            default:""
        },
        userCarts:{
            type:String,
            default:""
        },
    },
    data(){
        return{
            anonC:[],
            anonCsum:0,
            userC:[],
            userCsum:0,
            anonCload:false,
            userCload:false
        }
    },
    methods:{
        async fetchAnonCarts(){
            this.anonCload = true
            this.anonC = await getHandler(this.anonCarts, {error:false, success:false})
            this.anonCload = false
        },
        async fetchUserCarts(){
            this.userCload = true
            this.userC = await getHandler(this.userCarts, {error:false, success:false})
            this.userCload = false
        },
    },
    created(){
        this.fetchAnonCarts()
        this.fetchUserCarts()
    },
    watch:{
        anonC: function(val){
            var sum = 0
            for (var i in this.anonC){
                sum = sum + parseInt(this.anonC[i].totalInUy)
            }
            this.anonCsum = sum
        },
        userC: function(val){
            var sum = 0
            for (var i in this.userC){
                console.log(this.userC[i])
                sum = sum + parseInt(this.userC[i].totalInUy)
            }
            this.userCsum = sum
        }
    }
}
</script>

<style lang="scss" scoped>
.panel-heading{
    background:hsl(217, 71%, 53%);
    color: #fff;
}

</style>